import {CdFrequencyTag} from '../../../interfaces/care/cd-care-plan/cd-frequency-tag';

export class CdFrequencyTagFactory {
  public static fromObject(cdFrequencyTag: any): CdFrequencyTag {
    return new class implements CdFrequencyTag {
      color: string = cdFrequencyTag.color;
      service: string = cdFrequencyTag.service;
      periods: string = cdFrequencyTag.periods;
      periodsShort: string = cdFrequencyTag.periods_short;
      intervals: string = cdFrequencyTag.intervals;
      weekInterval: string = cdFrequencyTag.week_interval;
      text: string = cdFrequencyTag.text;
      shortText: string = cdFrequencyTag.short_text;
    };
  }

  public static fromArray(cdFrequencyTags: any[]): CdFrequencyTag[] {
    return cdFrequencyTags.map(_cdFrequencyTag => CdFrequencyTagFactory.fromObject(_cdFrequencyTag));
  }

}
